import Button from 'components/Button'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const Container = styled.div`
  padding: 0 60px 0 0;
`
export const ComanyDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_LG};
  line-height: 24px;
  color: ${COLORS.GREY_T_30};
`
export const CommonFlex = styled(Flex)`
  margin-top: 25px;
  width: 100%;
`
export const ImageSpan = styled.span`
  margin-left: 7px;
`
export const SubTitleDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  width: 46%;
`
export const FileInfoLi = styled.li`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  margin: 4px 0;
  color: ${COLORS.GREY_T_50_2};
`
export const ULTagElement = styled.ul`
  padding: 0 0 0 16px;
`
export const Divider = styled(Flex)`
  border-bottom: 1px solid ${COLORS.GREY_T_90};
  margin: 20px 0px;
  height: 56px;
`
export const AddLinkspan = styled.span`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.PRIMARY};
`
export const NoDataDiv = styled.div`
  margin: 50px 0;
`
export const PopoverImg = styled.embed`
  border-radius: 4.45455px;
  width: 400px;
  height: 250px;
`
export const DocumentFlex = styled(Flex)`
  gap: 10px;
`
export const PreviewDiv = styled.div`
  cursor: pointer;
`
export const AddMediaButton = styled(Button.Secondary)`
  border: none !important;
  background: none !important;
  box-shadow: none !important;
`
export const FooterFlex = styled(Flex)`
  gap: 15px;
`
